import { GetStaticProps } from 'next'
import { pageUtil } from '@/services/api/pageUtil'

export const getStaticProps: GetStaticProps = async () => {
  return pageUtil.getCampaignPageProps({
    campaignSlug: 'david-2',
    domain: 'thedavidmovie.com',
  })
}

export { default } from '@/components/pages/CampaignPages/CampaignPage'
